const messages = {
  'p.login.error':
    "Something went wrong and we can't sign you in right now. Please try again.",
  'p.login.welcome': 'Welcome to ABB EL China Digital Express Management System',
  'p.login.employee': 'ABB Employee',
  'p.login.employeetip': 'Sign in with ABB email',
  'p.login.customer': 'ABB Customer',
  'p.login.customertip': 'Query my orders',
  'p.errorpage.401': 'UNAUTHORIZED',
  'p.errorpage.403': 'FORBIDDEN',
  'p.errorpage.404': 'PAGE NOT FOUND',
  'p.errorpage.home': 'BACK TO HOME PAGE',
  'p.table.action': 'Actions',
  'p.table.status': 'Status',
  'p.table.lastupdatedby': 'Last Updated By',
  'p.table.lastupdatedtime': 'Last Updated Time',
  'p.table.remark': 'Remark',
  'p.masterdata.type': 'Data Type',
  'p.masterdata.text': 'Data Text',
  'p.masterdata.value': 'Data Value',
  'p.masterdata.mappingkey': 'Mapping Key',
  'p.masterdata.mappingkey2': 'Mapping Key2',
  'p.masterdata.IsEnabled': 'Is Enabled',
  'p.masterdata.displayindex': 'Display Index',
  'p.masterdata.createtitle': 'Create',
  'p.masterdata.edittitle': 'Update',
  'p.action.deleteconfirmtitle': 'Are you sure you want to delete this data?',  
  'p.action.authorizeconfirmtitle': 'Are you sure you want to initiate authorization?',
  'p.action.logoutconfirmtitle': 'Is it safe to exit?',
  'p.action.optionconfirmtitle': 'Are you sure you want to perform this operation?',  
  'p.emailtemplate.classify': 'Classify',
  'p.emailtemplate.name': 'Name',
  'p.emailtemplate.code': 'Code',
  'p.emailtemplate.subjecttemplate': 'Subject',
  'p.emailtemplate.bodytemplate': 'Content',
  'p.emailtemplate.createtitle': 'Create',
  'p.emailtemplate.edittitle': 'Update',  
  'p.table.createdby': 'Created By',
  'p.table.createdtime': 'Created Time',
  'p.carriers.no':'No.',
  'p.carriers.shippingtype':'Shipping Type',
  'p.carriers.name':'Name',
  'p.carriers.code':'Code',
  'p.carriers.carriername':'Carrier Name',
  'p.carriers.carriercode':'Carrier Code',
  'p.carriers.account':'Account',
  'p.carriers.password':'Password',
  'p.carriers.isenabled':'Is Enabled',
  'p.carriers.updatedate':'Update Date',
  'p.carriers.createtitle': 'Create',
  'p.carriers.edittitle': 'Update',
  'p.paymentaccount.title':'Payment Account List',
  'p.paymentaccount.no':'No.',
  'p.paymentaccount.company': 'Company',
  'p.paymentaccount.signedcarriername': 'Signed Carrier Name',
  'p.paymentaccount.signedcarriercode': 'Signed Carrier Code',
  'p.paymentaccount.taxcode': 'Tax Code',
  'p.paymentaccount.carrier': 'Carrier',
  'p.paymentaccount.carriername': 'Carrier Name',
  'p.paymentaccount.companyname':'Company Name',
  'p.paymentaccount.companycode':'Company Code',
  'p.paymentaccount.name':'Acount Name',
  'p.paymentaccount.number':'Acount Number',
  'p.paymentaccount.isenabled':'Is Enabled',
  'p.paymentaccount.updatedate':'Update Date',
  'p.paymentaccount.createtitle': 'Create',
  'p.paymentaccount.edittitle': 'Update',
  'p.carrieraccount.title':'Carrier Account List',
  'p.carrieraccount.no':'No.',
  'p.carrieraccount.company': 'Company',
  'p.carrieraccount.carrier': 'Carrier',
  'p.carrieraccount.carriername': 'Carrier Name',
  'p.carrieraccount.companyname':'Company Name',
  'p.carrieraccount.companycode':'Company Code',
  'p.carrieraccount.accounttype': 'Account Type',
  'p.carrieraccount.account':'Account',
  'p.carrieraccount.accountname':'Account Name',
  'p.carrieraccount.password':'Password',
  'p.carrieraccount.appkey': 'App Key',
  'p.carrieraccount.appsecret': 'App Secret',
  'p.carrieraccount.aessecret': 'AES Secret',
  'p.carrieraccount.uselevel': 'Use Level',
  'p.carrieraccount.tokenExpirationTime': 'Access Token Expiration Time',
  'p.carrieraccount.isenabled':'Is Enabled',
  'p.carrieraccount.updatedate':'Update Date',
  'p.carrieraccount.createtitle': 'Create',
  'p.carrieraccount.edittitle': 'Update',
  'p.freightbillaccount.company': 'Company',
  'p.freightbillaccount.carrier': 'Carrier',
  'p.freightbillaccount.carriername': 'Carrier Name',
  'p.freightbillaccount.companyname':'Company Name',
  'p.freightbillaccount.companycode':'Company Code',
  'p.freightbillaccount.synctype': 'Sync Type',
  'p.freightbillaccount.account':'Account',
  'p.freightbillaccount.accountname':'Account Name',
  'p.freightbillaccount.password':'Password',
  'p.freightbillaccount.sftphost': 'SFtp Host',
  'p.freightbillaccount.sftpport': 'SFtp Port',
  'p.freightbillaccount.sftpremotepath': 'SFtp Remote Path',
  'p.freightbillaccount.isenabled':'Is Enabled',
  'p.freightbillaccount.createtitle': 'Create',
  'p.freightbillaccount.edittitle': 'Update',
  'p.purchaserequest.requestno':'Request No.',
  'p.purchaserequest.podocumentno':'PO No.',
  'p.purchaserequest.applicant':'Requestor',
  'p.purchaserequest.applicantdate':'Request Date',
  'p.purchaserequest.status':'Status',
  'p.purchaserequest.carrier':'Carrier',
  'p.purchaserequest.billingmonth':'BillingMonth',
  'p.purchaserequest.company':'Company',
  'p.purchaserequest.totalamount':'Total Amount',
  'p.purchaserequest.currency':'Currency',
  'p.purchaserequest.signedcarrier':'Carrier No',
  'p.purchaserequest.plant':'Plant',
  'p.purchaserequest.department':'Department',
  'p.purchaserequest.area.basicinfo': 'Basic Information',
  'p.purchaserequest.confirmer': 'Billing Confirmed by',
  'p.purchaserequest.vendorno': 'Vendor No',
  'p.purchaserequest.taxcode': 'Tax Code',
  'p.purchaserequest.purchasegroup': 'Pur. Group',
  'p.purchaserequest.mdfcode': 'MDF Code',
  'p.purchaserequest.remark': 'Remark',
  'p.purchaserequest.area.detailinfo': 'Details Information',
  'p.purchaserequest.area.prchange': 'PR Item Change Request List',
  'p.purchaserequest.itemno': 'Item No.',
  'p.purchaserequest.costobjecttype': 'Cost Object Type',
  'p.purchaserequest.costobject': 'Cost Object',
  'p.purchaserequest.amount': 'Total Amount(VAT)',
  'p.purchaserequest.netamount': 'Net Price',
  'p.purchaserequest.materialgroup': 'Material Group',
  'p.purchaserequest.businessfunction': 'Business Function',
  'p.purchaserequest.area.processinfotitle': 'Approval Processing',
  'p.purchaserequest.area.approvalloginfotitle': 'Approval History',
  'p.purchaserequest.canceltitle': 'Cancel',
  'p.purchaserequest.reasons': 'Reasons',
  'p.shipments.dnno':'DN No.',
  'p.shipments.status':'Status',
  'p.shipments.dnstatus':'DN Status',
  'p.shipments.trackingno':'Tracking No.',
  'p.shipments.tcpno':'TCP No',
  'p.shipments.type':'Type',
  'p.shipments.shipmentcreatedate':'Shipment Create Date',
  'p.shipments.submittedby':'Submitted by',
  'p.shipments.carrier':'Carrier',
  'p.shipments.carriername': 'Carrier Name',
  'p.shipments.company':'Company',
  'p.shipments.deliverydate':'Delivery Date',
  'p.shipments.basicinformation':'Basic Information',
  'p.shipments.dn':'DN',
  'p.shipments.submitdate':'Submit Date',
  'p.shipments.pricerule':'Price Rule',
  'p.shipments.creator':'Creator',
  'p.shipments.pg':'PG',
  'p.shipments.mobile':'Mobile',
  'p.shipments.transportationtype':'Transportation Type',
  'p.shipments.plantcode':'Plant Code',
  'p.shipments.costobject':'Cost Object',
  'p.shipments.declaredvalue':'Declare Value',
  'p.shipments.unitofmeasurement':'Unit of Measurement',
  'p.shipments.currency':'Currency',
  'p.shipments.incoterm':'Incoterm',
  'p.shipments.shipperdetails':'Shipper Details',
  'p.shipments.countrycode':'Country/Region Code',
  'p.shipments.province':'Province',
  'p.shipments.city':'City',
  'p.shipments.postalcode':'Postal Code',
  'p.shipments.address':'Address',
  'p.shipments.contract':'Contact',
  'p.shipments.companyname':'Company Name',
  'p.shipments.tel':'Tel',
  'p.shipments.email':'eMail',
  'p.shipments.receiverdetails':'Receiver Details',
  'p.shipments.cargodetails':'Cargo Details',
  'p.shipments.huno':'HU No.',
  'p.shipments.length':'Length',
  'p.shipments.width':'Width',
  'p.shipments.height':'Height',
  'p.shipments.weight':'Weight',
  'p.shipments.itemno':'Item No.',
  'p.shipments.count':'Count',
  'p.shipments.materialdescription':'Material Description',
  'p.shipments.material':'Material',
  'p.shipments.serialno':'Serial No.',
  'p.shipments.price':'Price',
  'p.shipments.quantity':'Quantity',
  'p.shipments.hscode':'HS Code',
  'p.shipments.itemdetails':'Item Details',
  'p.shipments.duties':'Duties',
  'p.shipments.ordercreatedate':'Shipment Order Create Date',
  'p.shipments.createdtime': 'Created Time',
  'p.freight.uploadbillingfile':'Upload Billing File',
  'p.fedexfreightbill.ordernumber': 'Order No.',
  'p.fedexfreightbill.referenceno': 'Reference No.',
  'p.fedexfreightbill.trackingno':'Tracking No.',
  'p.fedexfreightbill.invoiceno':'Pre-invoice No.',
  'p.fedexfreightbill.freight':'Freight',
  'p.fedexfreightbill.fuelsurcharge':'Fuel Surcharge',
  'p.fedexfreightbill.otherscharge': 'Other Charges',
  'p.fedexfreightbill.amount': 'Amount',
  'p.fedexfreightbill.currency': 'Currency',
  'p.fedexfreightbill.shipmentdate': 'Ship Date',
  'p.fedexfreightbill.receivercountrycode': 'DES Country',
  'p.fedexfreightbill.shippercity': 'Shipper City',
  'p.fedexfreightbill.receivercity': 'Receiver City',
  'p.fedexfreightbill.billingmonth': 'Month of Billing',
  'p.fedexfreightbill.company': 'Company',
  'p.fedexfreightbill.monthlycard': 'Monthly Card',
  'p.fedexfreightbill.status': 'Status',
  'p.fedexfreightbill.department': 'Department',
  'p.fedexfreightbill.plant': 'Plant Code',
  'p.fedexfreightbill.costobject': 'Cost Object',
  'p.fedexfreightbill.approvaltitle': 'Bill Approval',
  'p.fedexfreightbill.action': 'Is Approved',
  'p.fedexfreightbill.approved': 'Approve',
  'p.fedexfreightbill.rejected': 'Reject',
  'p.fedexfreightbill.remark': 'ShippingRemark',
  'p.fedexfreightbill.cargodesc': 'CargoDesc',
  'p.fedexfreightbill.applicant': 'Applicant',
  'p.jdfreightbill.ordernumber': 'Order No.',
  'p.jdfreightbill.referenceno': 'Reference No.',
  'p.jdfreightbill.trackingno':'Tracking No.',
  'p.jdfreightbill.invoiceno':'Pre-invoice No.',
  'p.jdfreightbill.freight':'Freight',
  'p.jdfreightbill.freightamount':'Freight Amount',
  'p.jdfreightbill.othercharges': 'Other Charges',
  'p.jdfreightbill.amount': 'Amount',
  'p.jdfreightbill.currency': 'Currency',
  'p.jdfreightbill.shipmentdate': 'Ship Date',
  'p.jdfreightbill.status': 'Status',
  'p.jdfreightbill.tspnumber': 'TSP No.',
  'p.jdfreightbill.shippedfrom': 'Shipped From',
  'p.jdfreightbill.arrivedat': 'Arrived at',
  'p.jdfreightbill.province': 'Province',
  'p.jdfreightbill.receivername': 'Receiver Name',
  'p.jdfreightbill.receiveraddress': 'Receiver Address',
  'p.jdfreightbill.productname': 'Product Name',
  'p.jdfreightbill.carrier': 'Carrier',
  'p.jdfreightbill.settletype': 'Settle Type',
  'p.jdfreightbill.actualdeliverydate': 'Actual Delivery Date',
  'p.jdfreightbill.quantity': 'Quantity',
  'p.jdfreightbill.weight': 'Weight',
  'p.jdfreightbill.volume': 'Volume',
  'p.jdfreightbill.chargedweight': 'Charged Weight',
  'p.jdfreightbill.initialweight': 'Initial Weight',
  'p.jdfreightbill.addedweight': 'Added Weight',
  'p.jdfreightbill.discount': 'Discount',
  'p.jdfreightbill.ensuredvalue': 'Insured Value',
  'p.jdfreightbill.claim': 'Claim',
  'p.jdfreightbill.declarevalue': 'Declare Value',
  'p.jdfreightbill.effectivetime': 'Effective Time',
  'p.jdfreightbill.remark': 'ShippingRemark',
  'p.jdfreightbill.cargodesc': 'CargoDesc',
  'p.jdfreightbill.company': 'Company',
  'p.jdfreightbill.plant': 'Plant',
  'p.jdfreightbill.department': 'Department',
  'p.jdfreightbill.costobject': 'Cost Object',
  'p.jdfreightbill.monthlycard': 'Monthly Card',
  'p.jdfreightbill.applicant': 'Applicant',
  'p.sffreightbill.invoiceno': 'Pre-invoice No.',
  'p.sffreightbill.type': 'Type',
  'p.sffreightbill.freight':'Freight',
  'p.sffreightbill.discountamount':'Discount Amount',
  'p.sffreightbill.amount': 'Amount',
  'p.sffreightbill.currency': 'Currency',
  'p.sffreightbill.status': 'Status',
  'p.sffreightbill.shippercity': 'Arrived at',
  'p.sffreightbill.receivercity': 'Province',
  'p.sffreightbill.deliverydate': 'Delivery Date',
  'p.sffreightbill.remark': 'ShippingRemark',
  'p.sffreightbill.cargodesc': 'CargoDesc',
  'p.sffreightbill.company': 'Company',
  'p.sffreightbill.plant': 'Plant',
  'p.sffreightbill.department': 'Department',
  'p.sffreightbill.costobject': 'Cost Object',
  'p.sffreightbill.monthlycard': 'Monthly Card',
  'p.sffreightbill.ordernumber': 'Order No.',
  'p.sffreightbill.referenceno': 'Reference No.',
  'p.sffreightbill.trackingno':'Tracking No.',
  'p.sffreightbill.feetypename': 'Fee Type',
  'p.sffreightbill.handlername': 'Handler',
  'p.sffreightbill.payableamount': 'Payable Amount',
  'p.sffreightbill.discountAmount': 'Discount Amount',
  'p.sffreightbill.fee': 'Fee',
  'p.sffreightbill.paymentmethod': 'Payment Method',
  'p.sffreightbill.productname': 'Product Name',
  'p.sffreightbill.vehicletypecode': 'Vehicle Type Code',
  'p.sffreightbill.receivercontactname': 'Receiver Contact Name',
  'p.sffreightbill.itemnumber': 'Item No.',
  'p.sffreightbill.consignedtime': 'Consigned Time',
  'p.sffreightbill.deliverytime': 'Delivery Time',
  'p.sffreightbill.sourceordernumber': 'Source Order No.',
  'p.sffreightbill.originalordernumber': 'Original Order No.',
  'p.sffreightbill.orderstatus': 'Order Status',
  'p.sffreightbill.sendercontactname': 'Sender Contact Name',
  'p.sffreightbill.consignmentname': 'Consignment Name',
  'p.sffreightbill.distance': 'Distance',
  'p.sffreightbill.monthlycardnumber': 'Monthly Card No.',
  'p.sffreightbill.weight': 'Weight',
  'p.sffreightbill.billdate': 'Bill Date',
  'p.sffreightbill.discountmonthlyamount': 'Discount Monthly Amount',
  'p.sffreightbill.discountdate': 'Discount Date',
  'p.sffreightbill.senderarea': 'Sender Area',
  'p.sffreightbill.receiverarea': 'Receiver Area',
  'p.sffreightbill.othercustomername': 'Other Customer Name',
  'p.sffreightbill.servicename': 'Service Name',
  'p.sffreightbill.serviceremark': 'Service Remark',
  'p.sffreightbill.sendercompanyname': 'Sender Company Name',
  'p.sffreightbill.length': 'Length',
  'p.sffreightbill.width': 'Width',
  'p.sffreightbill.height': 'Height',
  'p.sffreightbill.receivercompanyname': 'Receiver Company Name',
  'p.sffreightbill.shippingtime': 'Shipping Time',
  'p.sffreightbill.consigneeemployeenumber': 'Consignee Employee No.',
  'p.sffreightbill.consignmentquantity': 'Consignment Qty.',
  'p.sffreightbill.quantity': 'Qty.',
  'p.sffreightbill.receiverprovince': 'Receiver Province',
  'p.sffreightbill.deliveremployeenumber': 'Deliver Employee No.',
  'p.sffreightbill.signedbackwaybillno': 'Signedback Waybill No.',
  'p.sffreightbill.signIntime': 'SignIn Time',
  'p.sffreightbill.additionalremark': 'Additional Remark',
  'p.sffreightbill.additionalremark2': 'Additional Remark 2',
  'p.sffreightbill.additionalremark3': 'Additional Remark 3',
  'p.sffreightbill.expresscontent': 'Express Content',
  'p.sffreightbill.areatype': 'Area Type',
  'p.sffreightbill.senderprovince': 'Sender Province',
  'p.sffreightbill.declaredvalue': 'Declared Value',
  'p.sffreightbill.volume': 'Volume',
  'p.sffreightbill.realweight': 'Real Weight',
  'p.sffreightbill.signInname': 'SignIn Name',
  'p.sffreightbill.specialweight': 'Special Weight',
  'p.sffreightbill.country': 'Country',
  'p.sffreightbill.returnedwaybillno': 'Returned Waybill No.',
  'p.sffreightbill.applicant': 'Applicant',
  'p.dhlfreightbill.ordernumber': 'Order No.',
  'p.dhlfreightbill.referenceno': 'Reference No.',
  'p.dhlfreightbill.trackingno':'Tracking No.',
  'p.dhlfreightbill.invoiceno':'Pre-invoice No.',
  'p.dhlfreightbill.freight':'Freight',
  'p.dhlfreightbill.fuelsurcharge':'Fuel Surcharge',
  'p.dhlfreightbill.otherscharge': 'Other Charges',
  'p.dhlfreightbill.amount': 'Amount',
  'p.dhlfreightbill.currency': 'Currency',
  'p.dhlfreightbill.shipmentdate': 'Ship Date',
  'p.dhlfreightbill.receivercountrycode': 'DES Country',
  'p.dhlfreightbill.shippercity': 'Shipper City',
  'p.dhlfreightbill.receivercity': 'Receiver City',
  'p.dhlfreightbill.billingmonth': 'Month of Billing',
  'p.dhlfreightbill.company': 'Company',
  'p.dhlfreightbill.monthlycard': 'Monthly Card',
  'p.dhlfreightbill.status': 'Status',
  'p.dhlfreightbill.department': 'Department',
  'p.dhlfreightbill.plant': 'Plant Code',
  'p.dhlfreightbill.costobject': 'Cost Object',
  'p.dhlfreightbill.approvaltitle': 'Bill Approval',
  'p.dhlfreightbill.action': 'Is Approved',
  'p.dhlfreightbill.approved': 'Approve',
  'p.dhlfreightbill.rejected': 'Reject',
  'p.dhlfreightbill.remark': 'ShippingRemark',
  'p.dhlfreightbill.cargodesc': 'CargoDesc',
  'p.dhlfreightbill.applicant': 'Applicant',

  'p.emsfreightbill.ordernumber': 'Order No.',
  'p.emsfreightbill.referenceno': 'Reference No.',
  'p.emsfreightbill.trackingno':'Tracking No.',
  'p.emsfreightbill.invoiceno':'Pre-invoice No.',
  'p.emsfreightbill.freight':'Freight',
  'p.emsfreightbill.fuelsurcharge':'Fuel Surcharge',
  'p.emsfreightbill.otherscharge': 'Other Charges',
  'p.emsfreightbill.amount': 'Amount',
  'p.emsfreightbill.currency': 'Currency',
  'p.emsfreightbill.shipmentdate': 'Ship Date',
  'p.emsfreightbill.receivercountrycode': 'DES Country',
  'p.emsfreightbill.shippercity': 'Shipper City',
  'p.emsfreightbill.receivercity': 'Receiver City',
  'p.emsfreightbill.billingmonth': 'Month of Billing',
  'p.emsfreightbill.company': 'Company',
  'p.emsfreightbill.monthlycard': 'Monthly Card',
  'p.emsfreightbill.status': 'Status',
  'p.emsfreightbill.department': 'Department',
  'p.emsfreightbill.plant': 'Plant Code',
  'p.emsfreightbill.costobject': 'Cost Object',
  'p.emsfreightbill.approvaltitle': 'Bill Approval',
  'p.emsfreightbill.action': 'Is Approved',
  'p.emsfreightbill.approved': 'Approve',
  'p.emsfreightbill.rejected': 'Reject',
  'p.emsfreightbill.remark': 'ShippingRemark',
  'p.emsfreightbill.cargodesc': 'CargoDesc',
  'p.emsfreightbill.applicant': 'Applicant',
  'p.freight.trackingno':'Tracking No.',
  'p.freight.invoiceno':'Pre-invoice No.',
  'p.freight.shippercity':'Shipper City',
  'p.freight.receivercity':'Receiver City',
  'p.freight.dn':'DN',
  'p.freight.billingmonth':'Month of Billing',
  'p.freight.company':'Company',
  'p.freight.companyname': 'Company Name',
  'p.freight.monthlycard':'Monthly Card',
  'p.freight.amount':'Amount',
  'p.freight.currency':'Currency',
  'p.freight.freightbilldate':'Date',
  'p.freight.receivercompany1':'Receiver Company 1',
  'p.freight.sfexrepresstype':'SF Exrepress Type',
  'p.freight.paymentmethod':'Payment Method',
  'p.freight.freight':'Freight',
  'p.freight.discount':'Discount',
  'p.freight.charge':'Charge',
  'p.freight.shippername1':'Shipper Name 1',
  'p.freight.servicetype':'Service Type',
  'p.freight.shippercompany':'Shipper Company',
  'p.freight.shippertel':'Shipper Tel',
  'p.freight.receivercompany2':'Receiver Company 2',
  'p.freight.receivertel':'Receiver Tel',
  'p.freight.shippername2':'Shipper Name 2',
  'p.freight.delverydate':'Delvery Date',
  'p.freight.originprovince':'Origin Province',
  'p.freight.shippercompanyaddress':'Shipper Company Address',
  'p.freight.sfreceiverno':'SF Receiver No.',
  'p.freight.commodityname':'Commodity Name',
  'p.freight.declarevalue':'Declare Value',
  'p.freight.pcs':'PCS',
  'p.freight.volume':'Volume',
  'p.freight.destinationprovince':'Destination Province',
  'p.freight.receivername':'Receiver Name',
  'p.freight.receiveraddress':'Receiver Address',
  'p.freight.sfdispatcherno':'SF Dispatcher No.',
  'p.freight.auturalweight':'Actural Weight ',
  'p.freight.signbacktrackingno':'Signback Tracking No.',
  'p.freight.receivedby':'Received by',
  'p.freight.receivetime':'Receive  Time',
  'p.freight.returnrelatedtrackingno':'Return related Tracking No.',
  'p.freight.extention1':'Extention 1',
  'p.freight.extention2':'Extention 2',
  'p.freight.extention3':'Extention 3',
  'p.freight.branchcompanyaccount':'Branch Company Account',
  'p.freight.orderno':'Order No.',
  'p.freight.remark':'Remark',
  'p.freight.sfexpress':'SF Express ',
  'p.freight.countrydistrict':'Country/District',
  'p.freight.regiontype':'Region Type',
  'p.freight.length':'Length',
  'p.freight.width':'Width',
  'p.freight.height':'Height',
  'p.freight.status':'Status',
  'p.freight.billingstatus':'Billing Status',
  'p.freight.account':'Account Number',
  'p.freight.accountnumber':'Invoice Number',
  'p.freight.trackingnumber':'Tracking Number',
  'p.freight.shipmentdate':'Ship Date',
  'p.freight.shippercountrycode':'Origin Country',
  'p.freight.shipperthreecharactercode':'Origin Port',
  'p.freight.shippercityname':'Origin City',
  'p.freight.receivercountrycode':'DES Country',
  'p.freight.receiverthreecharactercode':'Destination Port',
  'p.freight.receivercityname':'Destination City',
  'p.freight.shipperreferenceinformation':'Shipper Ref Number',
  'p.freight.shipperdisplayname':'Shipper Contact',
  'p.freitht.shippercompany':'Shipper Name',
  'p.freight.shipperdddress1':'Shipper Address 1',
  'p.freight.shipperdddress2':'Shipper Address 2',
  'p.freight.shipperpostalcode':'Origin Postal Code',
  'p.freight.receiverdisplayname':'Consignee Contact',
  'p.freight.receivercompany':'Consignee Name',
  'p.freight.receiveraddress1':'Consignee Address 1',
  'p.freight.receiverAddress2':'Consignee Address 2',
  'p.freight.receiverpostalcode':'Destination Postal Code',
  'p.freight.quantity':'Lading Quantity',
  'p.freight.billingweight':'Chargeable weight',
  'p.freight.goodsvalue':'Cargo Value',
  'p.freight.basecharge':'Main freight',
  'p.freight.fuelsurcharge':'Fuel Surcharge',
  'p.freight.remoteareadeliverycharge':'Remote Area P/D',
  'p.freight.overweightpricecharge':'Oversized Goods',
  'p.freight.nonstackablepalletcharge':'Non-stackable Goods',
  'p.freight.addresscorrectioncharge':'Address Correction',
  'p.freight.expressvalueinsurancecharge':'Premium',
  'p.freight.otherscharge':'Other Charges',
  'p.freight.shipperpaylandtarifftax':'Duty/Tax Paid by Shipper',
  'p.freight.documentprotection':'Document Fee',
  'p.freight.emergencysurcharge':'Emergency Surcharge',
  'p.freight.addedtax':'VAT',//增值税
  'p.freight.totalamount':'Total Amount',
  'p.freight.expensecode':'Expense Code',
  'p.freight.expensedescription':'Expense Description',
  'p.freight.area.otherchargesinfo': 'Expense Detail',
  'p.freightbill.confirmedby': 'Confirmed By',
  'p.freightbill.confirmedtime': 'Confirmed Time',
  'p.freightbill.confirmedremark': 'Confirmed Remark',
  'p.freightbill.approvedby': 'Approved By',
  'p.freightbill.approvedtime': 'Approved Time',
  'p.freightbill.approvedremark': 'Approved Remark',
  'p.freightbill.confirmtitle': 'Bill Confirm',
  'p.freightbill.totalamount': 'Total Amount',
  'p.freightbill.totalapproveamount': 'To-Approve Amount',
  'p.freightbill.totalconfirmamount': 'To-Confirm Amount',
  'p.purchaserequest.totalnetamount': 'Total Net Price',
  'p.waybill.area.basedatainfo': 'Basic information',
  'p.waybill.trackingno': 'Tracking No.',
  'p.waybill.createdate': 'Shipment Order Create Date',
  'p.waybill.status': 'Status',
  'p.waybill.carrier': 'Carrier',
  'p.waybill.area.trackinginfo': 'Tracking information',
  'p.print.ordernumber':'Order No.',
  'p.print.referenceno': 'Reference No.',
  'p.print.trackingno':'Tracking No.',
  'p.print.type': 'Shipping Type',
  'p.print.status':'Status',
  'p.print.createtime':'Created Time',
  'p.print.lastprinttime':'Last Printed Time',
  'p.print.company': 'Company',
  'p.print.plant': 'Plant Code',
  'p.print.department': 'Department',
  'p.print.carrier':'Carrier Name',
  'p.print.cargocount': 'Cargo Count',
  'p.print.shippercity':'Shipper City',
  'p.print.receivercity':'Receiver City',
  'p.print.waybilldoc':'Waybill doc.',
  'p.print.datasourcetype':'Data Sourcet',
  'p.action.cancelconfirmtitle':'Cancel this shipment order, you will not have the chance to print the Waybill Doc any more.Please confirm the right doc has been printed or DN packages have been picked up. Continue to Cancel?',
  'p.action.printconfirmtitle':'Print this Waybill Doc, you will cancel the previous shipment order. Continue to print?',
  'p.action.printconfirmtitle2':'This DN has more than one Tracking No. Please check information before you print.',
  'p.action.marknotpaytitle':'This record will be set to Not Ready to Confirm and not be allowed to create PO. Continue this action?',
  'p.action.marknotpaytitle2':'This record will be set to Ready to Confirm and be allowed to create PO. Continue this action?',
  'p.action.sendallpotitle':'This will send all the approved freight items of {BillingMonth} (ready to send) to DPPO?',
  'p.action.confirmbilling.confirmtitle': 'Are you sure you want to confirm the bill?',
  'p.company.name': 'Company Name',
  'p.company.code': 'Company Code',
  'p.company.contacts': 'Contacts',
  'p.company.carriers': 'Carriers',
  'p.company.isenabled': 'Is Enabled',
  'p.company.taxnumber': 'Tax No.',
  'p.company.taxtype': 'Tax Type',
  'p.company.taxcountrycode': 'Tax Country Code',
  'p.company.tax': 'Tax No.',
  'p.company.createtitle': 'Create',
  'p.department.name': 'Department Name',
  'p.department.code': 'Department Code',
  'p.department.company': 'Company Name',
  'p.department.defaultpaymentaccount': 'Payment Account',
  'p.department.isenabled': 'Is Enabled',
  'p.department.createtitle': 'Create',
  'p.department.edittitle': 'Update',
  'p.expressorder.area.addressinfotitle': 'Shipping Address Information',
  'p.expressorder.postalcode': 'Postal Code',
  'p.expressorder.province': 'Province',
  'p.expressorder.city': 'City',
  'p.expressorder.area': 'District',
  'p.expressorder.address': 'Address',
  'p.expressorder.contactname': 'Name',
  'p.expressorder.company': 'Company',
  'p.expressorder.mobile': 'Mobile No.',
  'p.expressorder.tel': 'Landline',
  'p.expressorder.email': 'Email',
  'p.expressorder.area.cargoinfotitle': 'Package Information',
  'p.expressorder.huIdentificationNo': 'HUIdentification No.',
  'p.expressorder.totalweight': 'Weight（KG）',
  'p.expressorder.totaldimensions': 'Dimensions（CM³）',
  'p.expressorder.trackingnumber': 'Tracking No.',
  'p.mobile.expressorder.description': 'Description',
  'p.expressorder.orderno': 'No.',
  'p.expressorder.itemno': 'Item No.',
  'p.expressorder.materialname': 'Material Name',
  'p.expressorder.materialdescription': 'Material Description',
  'p.expressorder.quality': 'Quality',
  'p.expressorder.createcargoitemtitle': 'Add Package Item',
  'p.expressorder.editcargoitemtitle': 'Update Package Item',
  'p.expressorder.selectaddresstitle': 'Addresses',
  'p.expressorder.area.orderinfotitle': 'Shipment Information',
  'p.expressorder.area.orderregistrationtitle': 'Receiver Registration Information',
  'p.expressorder.cnp': 'CNP',
  'p.expressorder.dun': 'DUN',
  'p.expressorder.ein': 'EIN',
  'p.expressorder.eor': 'EOR',
  'p.expressorder.fed': 'FED',
  'p.expressorder.ftz': 'FTZ',
  'p.expressorder.ssn': 'SSN',
  'p.expressorder.sta': 'STA',
  'p.expressorder.vat': 'VAT',
  'p.expressorder.plannedshippingdatetime': 'Planned Ship Time',
  'p.expressorder.tip': 'Internation Tip',
  'p.pickup.tip': 'Pick up address Tip',
  'p.expressorder.ispickuprequest': 'Pick Up',
  'p.expressorder.specialremarks': 'Waybill Remarks',
  'p.expressorder.partnernumber': 'Partner No.',
  'p.expressorder.issignback': 'Sign Back',
  'p.expressorder.cargotype': 'Cargo Type',
  'p.expressorder.isNeutraldelivery': 'Neutral Delivery',
  'p.expressorder.cargodescription': 'Cargo Desc.',
  'p.expressorder.area.baseinfotitle': 'Basic Information',
  'p.expressorder.plant': 'Plant',
  'p.expressorder.division': 'Division',
  'p.expressorder.pg': 'PG',
  'p.expressorder.costobjecttype': 'Cost Object Type',
  'p.expressorder.costobject': 'Cost Object',
  'p.expressorder.mobilephone': 'Mobile Phone',
  'p.expressorder.referenceno': 'Reference No.',
  'p.expressorder.carrier': 'Carrier',
  'p.expressorder.expresstype': 'Service Type',
  'p.expressorder.estimatedcost': 'Estimated Cost',
  'p.expressorder.estimateddeliverytime': 'Estimated Delivery Time',
  'p.expressorder.area.customsclearanceinfotitle': 'Declaration Information',
  'p.expressorder.area.orderregistrationtitle':'Registration Information',
  'p.expressorder.area.expressestimatedinfotitle': 'Shipping Services Estimated Information',
  'p.expressorder.createexportdeclarationitemtitle': 'Add Export Declaration Item',
  'p.expressorder.editexportdeclarationitemtitle': 'Update Export Declaration Item',
  'p.expressorder.taxpayer': 'Tax/Duty Paid by',
  'p.expressorder.businessno': 'Business No.',
  'p.expressorder.declarevalue': 'Declare Value',
  'p.expressorder.documenttype': 'Document Type',
  'p.expressorder.exportdeclarationitem.description': 'Material Description',
  'p.expressorder.exportdeclarationitem.itemname': 'Item Name',
  'p.expressorder.exportdeclarationitem.unitprice': 'Unit Price',
  'p.expressorder.exportdeclarationitem.totalamount': 'Total Amout',
  'p.expressorder.exportdeclarationitem.quantity': 'Quantity',
  'p.expressorder.exportdeclarationitem.unitofmeasurement': 'Unit of Measurement',
  'p.expressorder.exportdeclarationitem.manufacturercountry': 'Manufacturer Country',
  'p.expressorder.exportdeclarationitem.netweight': 'Net Weight(KG)',
  'p.expressorder.exportdeclarationitem.grossweight': 'Gross Weight(KG)',
  'p.expressorder.exportdeclarationitem.hscode': 'HS Code',
  'p.expressorder.exportdeclarationitem.outboundhscode': 'Outbound HS Code',
  'p.expressorder.exportdeclarationitem.inboundhscode': 'Inbound HS Code',
  'p.expressorder.area.invoiceinfotitle': 'Invoice Information',
  'p.expressorder.area.invoice.lineitemstitle': 'Line Items on Invoice',
  'p.expressorder.area.processinfotitle': 'Approval Processing',
  'p.expressorder.area.approvalloginfotitle': 'Approval log',
  'p.expressorder.invoice': 'Invoice',
  'p.expressorder.taxpayer.shipper': 'Shipper',
  'p.expressorder.taxpayer.receiver': 'Receiver',
  'p.expressorder.selectcarriertitle': 'Select Carrier Service',
  'p.expressorder.carrierservice': 'Carrier Service',
  'p.expressorder.paymentnumber': 'Payment No.',
  'p.expressorder.area.carrierserviceinfotitle': 'Carrier Service Information',
  'p.expressorder.canceltitle': 'Cancel',
  'p.expressorder.datasource': 'Data Source',
  'p.expressorder.department': 'Department',
  'p.addressbook.addressType': 'Address Type',
  'p.addressbook.contactname': 'Contact Name',
  'p.addressbook.address': 'Address',
  'p.addressbook.company': 'Company Name',
  'p.addressbook.email': 'Email',
  'p.addressbook.companyemail': 'Company/Email',
  'p.expressorder.country': 'Country/Region',
  'p.addressbook.mobiletel': 'Mobile Phone/Landline',
  'p.addressbook.createtitle': 'Create',
  'p.addressbook.edittitle': 'Update',
  'p.addressbook.country': 'Country/Region',
  'p.addressbook.countryname': 'Country/Region Name',
  'p.addressbook.postalcode': 'Postal Code',
  'p.addressbook.province': 'Province',
  'p.addressbook.city': 'City',
  'p.addressbook.area': 'District',
  'p.addressbook.mobile': 'Mobile No.',
  'p.addressbook.tel': 'Landline',
  'p.country.name': 'Country/Region',
  'p.country.nameen': 'English Name',
  'p.country.code': 'Code',
  'p.country.isenabled': 'Is Enabled',
  'p.country.createtitle': 'Create',
  'p.country.edittitle': 'Update',
  'p.state.country': 'Country/Region',
  'p.state.name': 'Name',
  'p.state.code': 'Code',
  'p.state.isenabled': 'Is Enabled',
  'p.state.createtitle': 'Create',
  'p.state.edittitle': 'Update',
  'p.hscode.code': 'HS Code',
  'p.hscode.description': 'Description',
  'p.hscode.firstlegalunitcode': 'First Legal Unit',
  'p.hscode.secondlegalunitcode': 'Second Legal Unit',
  'p.hscode.isenabled': 'Is Enabled',
  'p.hscode.createtitle': 'Create',
  'p.hscode.edittitle': 'Update',
  'p.legalunit.name': 'Unit Name',
  'p.legalunit.code': 'Unit Code',
  'p.legalunit.isenabled': 'Is Enabled',
  'p.legalunit.createtitle': 'Create',
  'p.legalunit.edittitle': 'Update',
  'p.expressorder.selectmaterialtitle': 'Please select Items',
  'p.expressorder.ordernumber': 'Order No.',
  'p.expressorder.status': 'Status',
  'p.expressorder.applicant': 'Applicant',
  'p.expressorder.applicationdate': 'Application Time',
  'p.expressorder.type': 'Express Type',
  'p.expressorder.reasons': 'Reasons',
  'p.expressorder.incoterm': 'Incoterm',
  'p.expressorder.warehouse': 'Warehouse',
  'p.expressorder.description': 'Description',
  'p.expressorder.remark': 'Reason for this Shipment',
  'p.expressorder.shippingremark': 'Shipping Remark',
  'p.expressorder.ensuredvalue': 'Insured Value',
  'p.expressorder.pickupdatetime': 'Pickup Time',
  'p.expressorder.pickupremark': 'Pickup Remark',
  'p.expressorder.enablePickupAddress': 'Pickup Address',
  'p.expressorder.package': 'Package',
  'p.expressorder.doc': 'Doc',
  'p.expressorder.yes': 'Yes',
  'p.expressorder.no': 'No',
  'p.expressorder.shipfrom': 'Ship From',
  'p.expressorder.shipto': 'Ship To',
  'p.expressorder.paymenttype': 'Settle Type',
  'p.expressorder.monthlycard': 'Monthly Settle',
  'p.expressorder.collectpayment': 'Freight Collect',
  'p.expressorder.area.attachmentinfotitle': 'Attachment Information',
  'p.expressorder.attachment': 'Attachments',
  'p.expressorder.isUseCNABB': 'Is Use CNABB Account',
  'p.sparrowtemplate.workflowname': 'Workflow Name',
  'p.sparrowtemplate.sparrowtoken': 'Sparrow Token',
  'p.sparrowtemplate.sparrowappcode': 'Sparrow App Code',
  'p.sparrowtemplate.sparrowworkflowcode': 'Sparrow Workflow Code',
  'p.sparrowtemplate.sparrowpushtaskurl': 'Sparrow Push Task Url',  
  'p.sparrowtemplate.isenabled': 'Is Enabled',
  'p.sparrowtemplate.sqlscript': 'SQL Script',
  'p.sparrowtemplate.xmltemplate': 'XML Template',
  'p.sparrowtemplate.createtitle': 'Create',
  'p.sparrowtemplate.edittitle': 'Update',
  'p.mobile.expressorder.remark': 'Reasons',
  'p.mobile.addressbook.email': 'Email',
  'p.mobile.expressorder.shippingremark': 'Shipping Remark',
  'p.mobile.expressorder.type': "Int'l Express",
  'p.mobile.expressorder.ordernumber': 'Order No.',
  'p.mobile.expressorder.referenceno': 'Reference No.',
  'p.mobile.expressorder.plant': 'Plant',
  'p.mobile.expressorder.costobjecttype': 'Cost Type',
  'p.mobile.expressorder.costobject': 'Cost Object',
  'p.mobile.expressorder.lasttracktime': 'Last Option Time',
  'p.mobile.expressorder.status': 'Status',
  'p.mobile.expressorder.applicationtime': 'Request Time',
  'p.mobile.expressorder.address': 'Address',
  'p.mobile.expressorder.shippingdatetime': 'Shipping Time',
  'p.mobile.expressorder.ispickuprequest': 'Pick Up',
  'p.mobile.expressorder.pickupdatetime': 'Pickup Time',
  'p.mobile.expressorder.pickupremark': 'Pickup Remark',
  'p.mobile.expressorder.enablePickupAddress': 'Pickup Address',
  'p.mobile.expressorder.issignback': 'Sign Back',
  'p.mobile.expressorder.paymenttype': 'Settle Type',
  'p.mobile.expressorder.cargotype': 'Cargo Type',
  'p.mobile.expressorder.ensuredvalue': 'Insured Value',
  'p.mobile.expressorder.cargodescription': 'Cargo Desc.',
  'p.mobile.expressorder.huidentificationno': 'HU No.',
  'p.mobile.expressorder.totalweight': 'Weight',
  'p.mobile.expressorder.totalvolume': 'Volume',
  'p.mobile.expressorder.packageinfotitle': 'Packages',
  'p.mobile.expressorder.attachmentinfotitle': 'Attachments',
  'p.mobile.expressorder.area.trackinfo': 'Tracking Info.',
  'p.mobile.required': 'Required',
  'p.mobile.expressorder.estimatedarrivedtimetitle': 'Select Carrier Service',
  'p.mobile.expressorder.estimatedcost': 'Cost',
  'p.mobile.expressorder.estimatedtime': 'Time',
  'p.mobile.expressorder.estimatedarrivedtime': 'Estimated Time',
  'p.mobile.expressorder.totalestimatedcost': 'Estimated Cost',
  'p.mobile.expressorder.cargoiteminfotitle': 'Items',
  'p.mobile.expressorder.quantity': 'Qty',
  'p.mobile.expressorder.itemno': 'Item No.',
  'p.mobile.expressorder.materialname': 'Material',
  'p.mobile.expressorder.materialdescription': 'Description',
  'p.mobile.expressorder.specialremarks': 'Pick Remark',
  'p.mobile.expressorder.paymentnumber': 'Payment No.',
  'p.mobile.expressorder.taxPayer': 'Tax/Duty Paid by',
  'p.mobile.expressorder.declarevalue': 'Declare Value',
  'p.mobile.expressorder.declarecurrency': 'Declare Currency',
  'p.mobile.addressbook.contactname': 'Contact Name',
  'p.mobile.addressbook.mobile': 'Mobile Phone',
  'p.mobile.addressbook.province': 'Province',
  'p.mobile.addressbook.city': 'City',
  'p.mobile.addressbook.address': 'Address',
  'p.mobile.addressbook.postalcode': 'Postal Code',
  'p.mobile.addressbook.companyname': 'Company',
  'p.mobile.addressbook.type': 'Local Address',
  'p.mobile.addressbook.country': 'Country/Region',
  'p.mobile.addressbook.provincecityarea': 'Province/City/Area',
  'p.mobile.expressorder.exportdeclarationinfotitle': 'Export Declaration',
  'p.mobile.exportdeclarationitem.itemname': 'Item Name',
  'p.mobile.exportdeclarationitem.hscode': 'HS Code',
  'p.mobile.exportdeclarationitem.unitprice': 'Unit Price',
  'p.mobile.exportdeclarationitem.totalamount': 'Total Amount',
  'p.mobile.exportdeclarationitem.quantity': 'Quantity',
  'p.mobile.exportdeclarationitem.unitofmeasurement': 'Unit of Measurement',
  'p.mobile.exportdeclarationitem.manufacturercountry': 'Manu facturer Country',
  'p.mobile.exportdeclarationitem.netweight': 'Net Weight(KG)',
  'p.mobile.exportdeclarationitem.grossweight': 'Gross Weight(KG)',
  'p.mobile.expressorder.incoterm': 'Incoterm',
  'p.mobile.expressorder.reason': 'Reasons',
  'p.mobile.expressorder.invoiceinfotitle': 'Invoice',
  'p.mobile.expressorder.documenttype': 'Doc. Type',
  'p.mobile.expressorder.uploadtips': 'Support format: pdf,gif,jpeg,png,tiff',
  'p.common.yes': 'Yes',
  'p.common.no': 'No',
  'p.common.copyfrom': 'Copy From',
  'p.process.remark': 'Approval Remark',
  'p.home.scan': 'Scan QR Code to Mobile Express',
  'p.home.support': 'Supports SF, JD, DHL, FedEx',
  'p.dashboard.area.filter': 'Filter',
  'p.dashborad.time': 'Actual Departure Date',
  'p.dashborad.plant': 'Plant',
  'p.dashborad.carrier': 'Carrier',
  'p.dashboard.area.datas': 'Data',
  'p.dashborad.delay': 'Delay',
  'p.dashborad.otprate': 'OTP %',
  'p.dashborad.netotd': 'Net OTD %',
  'p.dashborad.grossotdrate': 'Gross OTD %',
  'p.dashborad.huqty': 'Package Qty',
  'p.dashborad.dlhu': 'D&L Package',
  'p.dashborad.dlrate': 'D&L %',
  'p.dashborad.domesticcost': 'Total Billing Cost(CNY)',
  'p.dashborad.shipmentQTY': 'Shipment QTY',
  'p.dashborad.total': 'Total',
  'p.dashboard.area.domesticcosts': 'Domestic Costs',
  'p.dashboard.area.domesticotd': 'Domestic OTD',
  'p.dashboard.area.shipments': 'Shipments by Desitination',
  'p.common.application': 'Applicant',
  'p.common.applicationDate': 'Submit Date',
  'p.common.createdDate': 'Created Date',
  'p.common.validresult': 'Valid Status',
  'p.expressorder.batchimportexportdeclarationitemtitle': 'Batch Import Export Declaration Items',
  'p.dhlfreightbill.dataerrormessage': 'Data Error Message',
  'p.fedexfreightbill.dataerrormessage': 'Data Error Message',
  'p.jdfreightbill.dataerrormessage': 'Data Error Message',
  'p.sffreightbill.dataerrormessage': 'Data Error Message',
  'p.purchaserequest.area.attachmentinfotitle': 'Attachment Information',
  'p.purchaserequest.attachment': 'Attachments',
  'p.purchaserequest.edititemcostobjecttitle': 'Update Cost Object',
  'p.addressbook.isDefault': 'Is Default',
  'p.mobile.addressbook.isdefault': 'Is Default',
  'p.purchaserequest.goodsreceiptno': 'Goods Receipt Doc No.',
  'p.expressorder.signbackattachmenttitle': 'Sign Receipt Information',
  'p.expressorder.recipientPaymentNumber': 'Recipient Payment No.',
  'p.mobile.addressbook.recipientPaymentNumber': 'Recipient Payment No.',
  'p.expressorder.changeshippinginfo':"Change Shipping Info.",
  'p.expressorder.changeshippinginfo.modal.ok':"Save & Submit",
  'p.delegation.delegatefrom': 'Delegate From',
  'p.delegation.delegateto': 'Delegate To',
  'p.delegation.startfrom': 'From Date',
  'p.delegation.endto': 'To Date',
  'p.delegation.remark': 'Remarks',
  'p.delegation.status': 'Status',
  'p.delegation.createdby': 'Created By',
  'p.delegation.createdtime': 'Created Time',
  'p.delegation.lastupdatedby': 'Last Updated By',
  'p.delegation.lastupdatedtime': 'Last Updated Time',
  'p.delegation.action.disableconfirmtitle': 'Are you sure you want to disable this delegation?',
  'p.delegation.action.enableconfirmtitle': 'Are you sure you want to enable this delegation?'
};
export default messages;
